// extracted by mini-css-extract-plugin
module.exports = {"container":"_2FABArBW5TYNYLZx8j2zIx"};